import { Button, Card, CardBody, Col, Form, Label, Row } from "reactstrap";
import { CVC, CVVNumber, CardNumber, DebitCards, ExpirationDate, FullNameHere, Submit } from "../../../../constants";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";
import { DebitMonthList, DebitYearList } from "../../../../data/applications/ECommerce";
import FormInput from "./common/FormInput";
import SelectInput from "./common/SelectInput";

// This component is used to create a debit card form with fields for card details and an image preview.
const DebitCard = () => {
  return (
    <Col xxl="4" lg="6" className="box-col-6 debit-card">
      <Card>
        <CommonCardHeader title={DebitCards} headClass="pb-0" />
        <CardBody>
          <Form className="theme-form" onSubmit={(e) => e.preventDefault()}>
            <Row>
              <FormInput type="text" placeholder={FullNameHere} formClass="col-6 p-r-0" />
              <FormInput type="text" placeholder={CardNumber} formClass="col-6" />
              <FormInput type="text" placeholder={CVVNumber} formClass="col-6 p-r-0" />
              <FormInput type="text" placeholder={CVC} formClass="col-6" />
              <Col xs="12" className="p-b-20">
                <Label className="col-form-label">{ExpirationDate}</Label>
              </Col>
              <SelectInput size={1} data={DebitMonthList} selectClass="col-6 p-r-0" />
              <SelectInput size={1} data={DebitYearList} selectClass="col-6" />
            </Row>
            <Col xs="12">
              <Button color="primary">{Submit}</Button>
            </Col>
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default DebitCard;
